import { useState, useEffect, useCallback, Fragment } from 'react';
import { Link, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import { Button, CircularProgress, Grid, Typography, Tab, Tabs, TableCell } from '@mui/material';
import { Dialog, SelectField, Tooltip } from 'style-guide';
import OrderTable from './OrderTable/OrderTable';
import OrderForm from './OrderForm';
import OrderSearch from './OrderTable/OrderSearch';
import Tracker from 'shipTracker/Tracker';
import { styled } from '@mui/system';

import { sendRequest, sendRequest1, REQUEST_ACTIONS, setOrderData, setOrderData1, parseOrderData } from 'utils/Communicator';
import { COUNTRY_CODE_LIST } from 'constants/global-constants';
import { STAGES_OPTIONS, USA_STATES } from 'constants/global-constants';
import * as XLSX from 'xlsx';
import { addOrderFilter, addOrderFilterForExport, addSearchFilter, usePrevious, StyledTableCell, advancedSearchDefaultStyle, filterServiceProvider } from 'Utils';
import { onChatListChange, getOrders, onOrdersCountChange, onChatCountChange, onChatCountTChange, onChatCountCChange, onChatCountCTChange, onUserSpecificOrdersCountChange, onUnConfirmedOrdersCountChange, onPageChange } from 'reducers/order-reducers/ordersSlicer';
import {
    onSearchChange,
} from 'reducers/order-reducers/orderTableFilterSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { onUnConfirmedParcelsCountChange } from 'reducers/parcel-reducers/ordersSlicer';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AdvSearchDialog from './OrderTable/AdvSearchDialog';
import Customers from 'serviceProvider/Customers'
import {
    onUserNLDataChange,
    onUserUSDataChange,
    onUserILDataChange,
    onUserILNamesChange,
    onUserNLNamesChange,
    onUserUSNamesChange,
    onCustomerNamesChange,
    onSubModeDataChange,
    onShippingModeDataChange,
    onCountryOfOriginDataChange,
    onAirPoaDataChange,
    onAirPolDataChange,
    onLclPoaDataChange,
    onLclPolDataChange,
    onIncotermsDataChange,
    onFileCodesChange,
    onFCLType20DataChange,
    onFCLType40DataChange,
} from 'reducers/order-reducers/predefinedDataSlicer';
import {
    onConsigneeIdChange,
    onCountryOfOriginIdChange,
    onShipperIdChange,
    onShippingModeIdChange,
    onSubModeIdChange,
    onUserLocalIdChange,
    onUserTracerChange,
    onUserCustomsChange,
    onUserAbroadIdChange,
    onIlReminderDateChange,
    OnStageSearchChange,
    onReminderDateChange,
    onOriginStateChange,
    resetOrderTableFilterSlice,
    resetAdvancedSearchFilter,
    onUrgentShipmentChange,
    onBrokerIdChange,
    onSelectedLocationIndexChange,
    onSelectedTabIndexNameChange,
    onFileNumberChange,
    onSortFilterChange,
} from 'reducers/order-reducers/orderTableFilterSlicer';
import { onShipperNameOptionsChange, onShippersChange } from 'reducers/shippersSlicer';
import { onCustomerNameOptionsChange, onCustomersChange } from 'reducers/customersSlicer';
import { onConsigneeNameOptionsChange, onConsigneesChange } from 'reducers/consigneesSlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';

import { sendNewChatMsgNotification, sendNewOrderNotification } from 'utils/Notifications';

export const orderRowBgColor = {
    'background-color': '#057c054d',
}

var dataTimeout = null;
var lastServiceRefresh = null;

const Orders = ({ selectedOrder, loginUser, redboxParcels, agentOrders, setIsUsTime, isTrackerLoaded, setSearchText, searchText, filterSpinner, setFilterSpinner, setSelectedOrder }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const onHandleChange = (event, action) => dispatch(action(event.target.value));

    const { unConfirmedOrdersCount } = useSelector(state => state.orders);
    const { subModeData, shippingModeData, countryOfOriginData, userILData, userNLData, userUSData, userNLNames, lclPolData, lclPoaData, airPoaData, airPolData } = useSelector(
        state => state.predefinedData,
    );
    const { incotermsData, userILNames, fclType20Data, fclType40Data } = useSelector(
        state => state.predefinedData,
    );
    const { page, size, chatCount, userSpecificOrdersCount } = useSelector(state => state.orders);
    const prevPage = usePrevious({ page });
    const [isLoading, setIsLoading] = useState(false);
    const [activeSearch, setActiveSearch] = useState(true);
    const [endDate, setEndDate] = useState(null);
    const [incotermsId, setIncotermsId] = useState(null);
    const [userFU, setUserFU] = useState(null);
    const [rDate, setRDate] = useState(null);
    const [loc, setLoc] = useState(null);
    const [cId, setCId] = useState(null);
    const [sId, setSId] = useState(null);
    const [ssId, setSSId] = useState(null);
    const [bId, setBId] = useState(null);
    const [cList, setCList] = useState(null);
    const [sList, setSList] = useState(null);
    const [ssList, setSSList] = useState(null);
    const [bList, setBList] = useState(null);
    const [eDate, setEDate] = useState(null);
    const [usState, setUsState] = useState(null);
    const [ctrId, setCtrId] = useState(null);
    const [stageId, setStageId] = useState(null);

    const [pageSize, setPageSize] = useState(20);
    const [pageNum, setPageNum] = useState(0);
    const [advOrderCount, setAdvOrderCount] = useState(0);
    const [fileNameSearch, setFileNameSearch] = useState(true);

    const [shipperStatuses, setshipperStatuses] = useState([]);
    const [truckingStatuses, settruckingStatuses] = useState([]);
    const [departureStatuses, setdepartureStatuses] = useState([]);
    //const { orders } = useSelector(state => state.orders);
    const [isTrackerLoaded1, setIsTrackerLoaded1] = useState(false);
    const onHandleSelectedLocationTrackerChange = (event, newValue) => {
        navigate("/tracker")
        /*if (newValue == 0) {
            navigate("/settings/Tracker")
        } else {
            setIsUsTime(0)
        }*/
    }
    const onHideTracker = () => {
    }
    const [showCRM, setShowCRM] = useState(false);
    const onHandleSelectedLocationCRM = (event, newValue) => {
        //navigate("/crm")
        dispatch(onSelectedLocationIndexChange(-1));
        setShowCRM(true);
    }
    const onHandleSelectedLocationIndexChange = (event, newValue) => {
        setShowCRM(false);
        setSearchText("");
        navigate("/home")
        dispatch(resetOrderTableFilterSlice(null));
        dispatch(onUserAbroadIdChange(null));
        if (newValue === 'US') {
            setIsUsTime(1)
        } else {
            setIsUsTime(0)
        }
        dispatch(onPageChange(0));
        dispatch(onSelectedLocationIndexChange(newValue));
    }

    const {
        userLocalNumber,
        userAbroadNumber,
        consigneeId,
        customerId,
        shipperId,
        countryOfOriginId, originState, fileNumber,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms,
        urgentShipment,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        etaDate,
        etdDate,
        reminderDate,
        selectedLocationIndex,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        fileUploadStatus,
        stageStateSearch, selectedTabIndexName,
        reminderDateAdv, ilReminderDateAdv, sortFilter } = useSelector(state => state.orderTableFilter);
    const [airPolId, setAirPolId] = useState(null);
    const [airPodId, setAirPodId] = useState(null);
    const [seaPolId, setSeaPolId] = useState(null);
    const [seaPodId, setSeaPodId] = useState(null);
    const [etaStart, setEtaStart] = useState(null);
    const [etaEnd, setEtaEnd] = useState(null);
    const [etdStart, setEtdStart] = useState(null);
    const [etdEnd, setEtdEnd] = useState(null);
    const [reminderStart, setReminderStart] = useState(null);
    const [reminderEnd, setReminderEnd] = useState(null);
    const setAirPol = (data) => {
        setAirPolId(data);
        setSeaPolId(null);
    }
    const setSeaPol = (data) => {
        setAirPolId(null);
        setSeaPolId(data);
    }
    const setAirPod = (data) => {
        setAirPodId(data);
        setSeaPodId(null);
    }
    const setSeaPod = (data) => {
        setAirPodId(null);
        setSeaPodId(data);
    }
    const [sortFilter1, setSortFilter1] = useState({
        nlno: null,
        fu: null,
        ops: null,
        customs: null,
        type: null,
        orgCtr: null,
        orgUS: null,
        shipper: null,
        consignee: null,
        brooker: null,
        etd: null,
        eta: null,
        pol: null,
        pod: null,
        po: null,
        reminder: null,
        date: null,
        clientref: null,
        location: null,
    });
    const clearSort = () => {
        return {
            nlno: null,
            fu: null,
            ops: null,
            customs: null,
            type: null,
            orgCtr: null,
            orgUS: null,
            shipper: null,
            consignee: null,
            brooker: null,
            etd: null,
            eta: null,
            pol: null,
            pod: null,
            po: null,
            reminder: null,
            date: null,
            clientref: null,
            location: null,
        };
    }

    /*const {
        userLocalNumber,
        userAbroadNumber,
        consigneeId,
        customerId,
        shipperId,
        countryOfOriginId, originState,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms, urgentShipment, fileNumber,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        selectedTabIndexName,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv, } = useSelector(state => state.orderTableFilter);*/
    const orderTableFilter = {
        userLocalNumber,
        userAbroadNumber,
        consigneeId,
        shipperId,
        countryOfOriginId, originState,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms, urgentShipment, fileNumber,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        selectedTabIndexName,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv, sortFilter
    };
    const { shippers } = useSelector(state => state.shippers);
    const { customers } = useSelector(state => state.customers);
    const { consignees } = useSelector(state => state.consignees);
    const [brokers, setBrokers] = useState([]);
    const [coloaders, setColoaders] = useState([]);


    useEffect(() => {
        var spList = shippers.map(sp => {
            return {
                id: sp.id,
                name: sp.companyName
            };
        });
        setSList(spList);
    }, [shippers]);
    useEffect(() => {
        var spList = consignees.map(sp => {
            return {
                id: sp.id,
                name: sp.companyName
            };
        });
        setCList(spList);
    }, [consignees]);
    useEffect(() => {
        var spList = brokers.map(sp => {
            return {
                id: sp.id,
                name: sp.companyName
            };
        });
        setBList(spList);
    }, [brokers]);
    useEffect(() => {
        var spList = shippingModeData.map(sp => {
            return {
                id: sp.id,
                name: sp.name
            };
        });
        setSSList(spList);
    }, [shippingModeData]);

    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const [isLoaded, setIsLoaded] = useState(true);
    const [searchSpinner, setSearchSpinner] = useState(false);

    const [globalSearchList, setGlobalSearchList] = useState([]);
    const [globalSearchList1, setGlobalSearchList1] = useState([]);
    const [globalSearch, setGlobalSearch] = useState("");
    const [advSearchDialog, setAdvSearchDialog] = useState(false);
    const [userILImporters, setUserILImporters] = useState(false);
    const [userILSales, setUserILSales] = useState(false);
    const [userILSalesId, setUserILSalesId] = useState();
    const onHandleCancelAdvSearchDialog = () => setAdvSearchDialog(false);
    const onHandleOpenAdvSearchDialog = () => setAdvSearchDialog(true);
    const resetSearch = () => {
        setGlobalSearchList([]);
        setGlobalSearchList1([]);
        setPageNum(0);
        setAdvOrderCount(0);
    }
    const setSearchResult = (sort, ps, pn) => {
        setIsLoading(true);
        var list = [];
        setGlobalSearchList(list);
        var qp = "";
        if (loginUser.authority != "Admin" && loginUser.department != 4) {
            if (loginUser.department) {
                qp += "&userVisibility=" + loginUser.department;
            } else
                qp += "&userVisibility=1";
        }
        if (cId)
            qp += `&consigneeId=${cId}`;
        if (sId)
            qp += `&shipperId=${sId}`;
        if (bId)
            qp += `&customerId=${bId}`;
        if (ssId)
            qp += `&shippingModeId=${ssId}`;
        if (eDate) {
            var dt = new Date(eDate);
            dt.setUTCHours(23, 59, 59, 999);
            qp += `&etaDate=${dt.getTime()}`;
        }
        if (usState)
            qp += `&originState=${usState}`;
        if (ctrId)
            qp += `&countryOfOriginId=${ctrId}`;
        if (stageId)
            qp += `&stageSearch=${stageId}`;
        if (loc)
            qp += `&selectedLocation=${loc === "OTHERS" ? "ALL" : (loc === "EXP" ? "IL" : loc)}`;
        if (sort) {
            if (sort.date) {
                qp += `&sortdate=${sort.date}`;
            }
            if (sort.clientref) {
                qp += `&sortclientref=${sort.clientref}`;
            }
            if (sort.consignee) {
                qp += `&sortconsignee=${sort.consignee}`;
            }
            if (sort.shipper) {
                qp += `&sortshipper=${sort.shipper}`;
            }
            if (sort.brooker) {
                qp += `&sortbrooker=${sort.brooker}`;
            }
            if (sort.type) {
                qp += `&sorttype=${sort.type}`;
            }
            if (sort.etd) {
                qp += `&sortetd=${sort.etd}`;
            }
            if (sort.eta) {
                qp += `&sorteta=${sort.eta}`;
            }
            if (sort.orgCtr) {
                qp += `&sortorgctr=${sort.orgCtr}`;
            }
            if (sort.orgUS) {
                qp += `&sortorgus=${sort.orgUS}`;
            }
            if (sort.pol) {
                qp += `&sortpol=${sort.pol}`;
            }
            if (sort.pod) {
                qp += `&sortpod=${sort.pod}`;
            }
            if (sort.po) {
                qp += `&sortpo=${sort.po}`;
            }
            if (sort.reminder) {
                qp += `&sortreminder=${sort.reminder}`;
            }
            if (sort.location) {
                qp += `&sortlocation=${sort.location}`;
            }
        }
        if (airPolId) {
            qp += `&polId=${airPolId}`;
        } else if (seaPolId) {
            qp += `&polId=${seaPolId}`;
        }
        if (airPodId) {
            qp += `&podId=${airPodId}`;
        } else if (seaPodId) {
            qp += `&podId=${seaPodId}`;
        }
        if (etaStart) {
            var dt = new Date(etaStart);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&endEta=${utcTimestamp.getTime()}`;
        }
        if (etaEnd) {
            var dt = new Date(etaEnd);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&endEta=${utcTimestamp.getTime()}`;
        }
        if (etdStart) {
            var dt = new Date(etdStart);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&endEta=${utcTimestamp.getTime()}`;
        }
        if (etdEnd) {
            var dt = new Date(etdEnd);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&endEta=${utcTimestamp.getTime()}`;
        }
        if (reminderStart) {
            var dt = new Date(reminderStart);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            if (loginUser.location.id == 1)
                qp += `&startReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
            else
                qp += `&startIlReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
        }
        if (reminderEnd) {
            var dt = new Date(reminderEnd);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            if (loginUser.location.id == 1)
                qp += `&endReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
            else
                qp += `&endIlReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
        }
            
        sendRequest("/api/order/count?showUnassignedOrders=true&" + (loginUser.department ? "dep=" + loginUser.department : "dep=1") + (endDate ? "&endDate=" + endDate : "") + (incotermsId ? "&incotermsId=" + incotermsId : "") + (globalSearch?.trim() ? "&search=" + globalSearch?.trim() : "") + (activeSearch ? "&showHistoryOrdersOnly=false" : "&showHistoryOrdersOnly=true") + (userILSalesId ? ("&userLocalSalesId=" + userILSalesId) : "") + (userFU ? ("&userLocalId=" + userFU) : "") + (userFU ? ("&userILId=" + userFU) : "") + (rDate ? ("&ilReminderDate=" + rDate) : "") + qp, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var ordersCount = response.ordersCount;
                if (ordersCount < 1) {
                    setIsLoading(false);
                    return;
                }
                setAdvOrderCount(ordersCount);
                sendRequest("/api/order/advOrders?showUnassignedOrders=true&" + (loginUser.department ? "dep=" + loginUser.department : "dep=1") + (ps ? "&size=" + ps : "") + (pn ? "&page=" + pn : "") + (endDate ? "&endDate=" + endDate : "") + (incotermsId ? "&incotermsId=" + incotermsId : "") + (globalSearch?.trim() ? "&search=" + globalSearch?.trim() : "") + (activeSearch ? "&sort=2&showHistoryOrdersOnly=false" : "&sort=2&showHistoryOrdersOnly=true") + (userILSalesId ? ("&userLocalSalesId=" + userILSalesId) : "") + (userFU ? ("&userLocalId=" + userFU) : "") + (userFU ? ("&userILId=" + userFU) : "") + (rDate ? ("&ilReminderDate=" + rDate) : "") + qp, REQUEST_ACTIONS.GET, '', {
                    successCallback: resp => {
                        var response = resp;
                        response = parseOrderData(resp);
                        var responses = [];
                        var alerts = [];
                        for (var i = 0; i < response.length; i++) {

                            var query = getLocationFromId(response[i].location?.id);
                            if (loginUser.authority != "Admin") {
                                if (loginUser.department == null && response[i].visibilityWH)
                                    query += "-H";
                                else if (loginUser.department == 1 && response[i].visibilityWH)
                                    query += "-H";
                                else if (loginUser.department == 2 && response[i].visibilityT)
                                    query += "-H";
                                else if (loginUser.department == 3 && response[i].visibilityC)
                                    query += "-H";
                            } else if (response[i].historyFlag) {
                                query += "-H";
                            }
                            var reminderDateDisplay = response[i].ilRemindDate && loginUser?.location?.code === 'IL' ? new Intl.DateTimeFormat('en-GB', {
                                year: '2-digit',
                                month: '2-digit',
                                day: '2-digit',
                            }).format(response[i].ilRemindDate) :
                                response[i].remindDate && loginUser?.location?.code != 'IL' ? new Intl.DateTimeFormat('en-GB', {
                                    year: '2-digit',
                                    month: '2-digit',
                                    day: '2-digit',
                                }).format(response[i].remindDate) : '...';
                            var broker = response[i].customer;
                            var consignee = response[i].consignee;
                            var shipper = response[i].shipper;
                            list.push({
                                jobNumber: response[i].jobNumber,
                                date: formatDateTime(response[i].date),
                                rDate: reminderDateDisplay,
                                customerName: consignee?.companyShortName ? consignee?.companyShortName : (consignee?.companyName ? consignee?.companyName : "-"),
                                clientPo: response[i].clientRefNumber,
                                shipperName: shipper?.companyShortName ? shipper?.companyShortName : (shipper?.companyName ? shipper?.companyName : "-"),
                                mode: response[i].shippingMode?.id == 3 ? "FCL" : (response[i].shippingMode?.id == 2 ? "LCL" : "AIR"),
                                eta: getETA(response[i]),
                                etd: getETD(response[i]),
                                pol: response[i].pol?.name,
                                pod: response[i].poa?.name,
                                origin: (response[i].location?.id != "4" ? countryOfOriginData.find(cty => cty.id == response[i].countryOfOrigin?.id)?.name : USA_STATES.find(state => state.id == response[i].originState)?.name),
                                status: getLastEvent1(response[i]),
                                fileNumber: getFileNumber(response[i]),
                                location: query,
                                salesman: userILNames.find(il => il.id == response[i].userILSalesId)?.name,
                                broker: broker?.companyShortName ? broker?.companyShortName : (broker?.companyName ? broker?.companyName : ""),
                            });
                            responses.push(response[i]);
                        }
                        setIsLoading(false);
                        setGlobalSearchList(list);
                        setGlobalSearchList1(responses);
                    },
                    failedCallback,
                });
            },
            failedCallback,
        });
    }
    const getLocationFromId = (id) => {
        if (Number(id) == 1) {
            return "NL";
        } else if (Number(id) == 2) {
            return "EXP";
        } else if (Number(id) == 4) {
            return "US";
        } else if (Number(id) == 5) {
            return "ALL"
        }
    }

    const [selectedGeneral, setSelectedGeneral] = useState(true);
    const [openOrderDialog, setOpenOrderDialog] = useState(false);
    const onHandleOpenDialog = () => setOpenOrderDialog(true);
    const onHandleCancelDialog = () => setOpenOrderDialog(false);
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(resetOrderTableFilterSlice(null));
        if (location?.state?.name == "location") {
            var loc = (location?.state.locInd && location?.state.locInd != -1) ? location?.state.locInd : 0;
            dispatch(onSelectedLocationIndexChange(loc));
            dispatch(onSelectedTabIndexNameChange(location?.state?.tabInd));
            dispatch(onSearchChange(location?.state?.search));
            setGlobalSearch(location?.state?.searchText);
            setGlobalSearchList(location?.state?.searchList);
            setGlobalSearchList1(location?.state?.searchList1);
        } else {
            if (loginUser) {
                if (loginUser.location.id == 1) {
                    dispatch(onSelectedLocationIndexChange(0));
                }
                if (loginUser.location.id == 4) {
                    dispatch(onSelectedLocationIndexChange(1));
                    setUserILSalesId(loginUser?.id);
                }
            }
        }
    }, []);
    useEffect(() => {
        var sales = [];
        sales = userILNames.filter(name => name.department == 4);
        setUserILSales(sales);

        var importers = [];
        importers = userILNames.filter(name => name.department == 1 || name.department == null);
        setUserILImporters(importers);
    }, [userILNames]);
    useEffect(() => {
        if (loginUser) {
            if (loginUser.location.id == 1) {
                dispatch(onSelectedLocationIndexChange(0));
            }
            if (loginUser.location.id == 4) {
                dispatch(onSelectedLocationIndexChange(1));
                setUserILSalesId(loginUser?.id);
            }
        }
    }, [loginUser]);

    useEffect(() => {
        return () => {
            clearInterval(dataTimeout);
        }
    }, []);
    const updateObjects = (list, object) => {
        var newList = [];
        for (var i = 0; i < list.length; i++) {
            if (list[i].id != object.id) {
                newList.push(list[i]);
            } else {
                newList.push(object);
            }
        }
        return newList;
    }
    useEffect(() => {

        if (dataTimeout) {
            clearInterval(dataTimeout);
        }
        dataTimeout = setInterval(() => {
            sendRequest('/api/usersAll', REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    console.log(response);
                    dispatch(onUserILDataChange(response.IL));
                    dispatch(onUserNLDataChange(response.NL));
                    dispatch(onUserUSDataChange(response.US));
                },
                failedCallback,
            });
            sendRequest('/api/serviceProvider/lastUpdate', REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    if (response != lastServiceRefresh) {
                        sendRequest('/api/serviceProvider/allByDate/' + lastServiceRefresh, REQUEST_ACTIONS.GET, '', {
                            successCallback: response => {
                                var s1 = response?.s1;
                                var ship = JSON.parse(JSON.stringify(shippers));
                                for (var i = 0; i < s1.length; i++) {
                                    ship = updateObjects(ship, s1[i]);
                                }
                                dispatch(onShippersChange(ship));

                                var s2 = response?.s2;
                                var cons = JSON.parse(JSON.stringify(consignees));
                                for (var i = 0; i < s2.length; i++) {
                                    cons = updateObjects(cons, s2[i]);
                                }
                                dispatch(onConsigneesChange(cons));

                                var s8 = response?.s8;
                                var col = JSON.parse(JSON.stringify(coloaders));
                                for (var i = 0; i < s8.length; i++) {
                                    col = updateObjects(col, s8[i]);
                                }
                                setColoaders(col);

                                var s13 = response?.s13;
                                var cust = JSON.parse(JSON.stringify(customers));
                                for (var i = 0; i < s13.length; i++) {
                                    cust = updateObjects(cust, s13[i]);
                                }
                                dispatch(onCustomersChange(cust));

                                var s12 = response?.s12;
                                var brok = JSON.parse(JSON.stringify(brokers));
                                for (var i = 0; i < s12.length; i++) {
                                    brok = updateObjects(brok, s12[i]);
                                }
                                setBrokers(brok);
                            },
                            failedCallback,
                        });
                        lastServiceRefresh = response;
                    }
                },
                failedCallback,
            });

        }, 30000);
    }, [shippers, brokers, customers, coloaders, consignees]);

    const jsonToExcel = function (data, name, header) {
        var ws = XLSX.utils.json_to_sheet(data, header);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All");
        XLSX.writeFile(wb, name + ".xlsx");
    }
    const csvExport = () => {
        setSearchSpinner(true);
        console.log("CSV export from main page");
        sendRequest1(
            `/api/order/advOrders?${addOrderFilterForExport(loginUser, "O", selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, "O", sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}&page=0&size=100000`,
            REQUEST_ACTIONS.GET,
            '',
            {
                successCallback: resp => {
                    //console.log("data ======================");
                    setOrderData(dispatch, getOrders, resp, loginUser, failedCallback, function (reap) {
                        //console.log("for ======================");
                        if (!reap)
                            return;
                        var data_main = [];
                        var header = ["File", "JOB", "PO", "Supplier Name", "Co-Loader", "QTY", "Package", "Weight", "Volume", "INCOTERMS", "Origin Country", "Load Port", "Discharge Port", "ETD", "ETA", "Vessel name", "Container", "Last Cus. Event", "Reminder", "TRANSPORT", "ARRIVAL", "TELEX MBL", "TELEX HBL", "Salesman", "Broker", "Free days"]
                        //data_main.push(header);
                        for (var i = 0; i < reap.length; i++) {
                            var query = getLocationFromId(reap[i].location?.id);
                            if (loginUser.authority != "Admin") {
                                if (loginUser.department == null && reap[i].visibilityWH)
                                    query += "-H";
                                else if (loginUser.department == 1 && reap[i].visibilityWH)
                                    query += "-H";
                                else if (loginUser.department == 2 && reap[i].visibilityT)
                                    query += "-H";
                                else if (loginUser.department == 3 && reap[i].visibilityC)
                                    query += "-H";
                            } else if (reap[i].historyFlag) {
                                query += "-H";
                            }
                            var eta = getETAE(reap[i]);
                            var etd = getETDE(reap[i]);
                            var pol = getPOL(reap[i]);
                            var pod = getPOD(reap[i]);
                            var origin = getOriginCountry(reap[i]);
                            var companyName = "";
                            if (reap[i].shippingModeId == 1)
                                companyName = (reap[i].orderStage[4].departureStage[0]?.airline ? reap[i].orderStage[4].departureStage[0]?.airline : "");
                            else
                                companyName = (reap[i].orderStage[4].departureStage[0]?.shippingLineName ? reap[i].orderStage[4].departureStage[0]?.shippingLineName : "");
                            var inco = getIncoterms(reap[i]);
                            var vol = getOrderVolume(reap[i]);
                            var wt = getOrderWeight(reap[i]);
                            var qty = getOrderQuantity(reap[i]);
                            //var broker = brokers.find(br => br.id == reap[i].customer?.id);
                            var broker = reap[i].customer;
                            var consignee = reap[i].consignee;
                            var shipper = reap[i].shipper;
                            var data = {
                                "Customer": consignee?.companyShortName ? consignee?.companyShortName : (consignee?.companyName ? consignee.companyName : "-"),
                                "File": getFileNumber(reap[i]),
                                "JOB": reap[i].jobNumber ? reap[i].jobNumber : "-",
                                "Client Ref": reap[i]?.clientRefNumber ? reap[i]?.clientRefNumber : "-",
                                "F/U": userILData.find(user => user.id == reap[i]?.userIL?.id)?.fullName,
                                "Sub Mode": getSubMode(reap[i]),
                                "Supplier Name": shipper?.companyShortName ? shipper?.companyShortName : (shipper?.companyName ? shipper.companyName : "-"),
                                "Co-Loader": getCoLoader(reap[i]),
                                "QTY": qty,
                                "Package": reap[i].shippingMode?.id == 3 ? getFCLType(reap[i]) : "-",
                                "Weight": wt,
                                "Volume": vol,
                                "INCOTERMS": inco,
                                "Origin Country": origin,
                                "Load Port": pol,
                                "Discharge Port": pod,
                                "ETD": etd,
                                "ETA": eta,
                                "CC": reap[i]?.consignee?.useCustoms ? false : true,
                                "Vessel name": (reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.vesselNumber) ? reap[i]?.orderStage[4]?.departureStage[0]?.vesselNumber : "-",
                                "Company Name": companyName,
                                "MAWB": reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.master ? reap[i]?.orderStage[4]?.departureStage[0]?.master : "-",
                                "HAWB": reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.house ? reap[i]?.orderStage[4]?.departureStage[0]?.house : "-",
                                "Container": (reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.containerNumber) ? reap[i]?.orderStage[4]?.departureStage[0]?.containerNumber : "-",
                                "Last Cus. Event": getLastEvent1(reap[i]),
                                "Reminder": getILReminder(reap[i]),
                                "TRANSPORT": reap[i].shippingMode?.id == 1 ? "AIR" : (reap[i].shippingMode?.id == 2 ? "LCL" : "FCL"),
                                "ARRIVAL": getGap(reap[i]),
                                "TELEX MBL": reap[i].orderStage[4]?.departureStage[0]?.telexMbl ? true : false,
                                "TELEX HBL": reap[i].orderStage[4]?.departureStage[0]?.telexHbl ? true : false,
                                "Salesman": userILNames.find(il => il.id == reap[i].userILSales?.id)?.name,
                                "Broker": broker?.companyShortName ? broker?.companyShortName : (broker?.companyName ? broker.companyName : "-"),
                                "Free Days": reap[i].freeDays,
                                "WH": query
                            };
                            data_main.push(data);
                        }
                        console.log("data: " + data_main);
                        jsonToExcel(data_main, "orders", header);
                        console.log("Create xlsx");
                        //setSearchSpinner(false);
                        sendRequest(`/api/order/count?${addOrderFilter(loginUser, "Orders", selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, "Orders", sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}`, REQUEST_ACTIONS.GET, '', {
                            successCallback: response => {
                                dispatch(onOrdersCountChange(response?.ordersCount));
                                sendNewChatMsgNotification(loginUser, dispatch, chatCount, response?.unreadChatCount);
                                dispatch(onChatCountChange(response?.unreadChatCount));
                                dispatch(onChatCountTChange(response?.unreadChatTracerCount));
                                dispatch(onChatCountCChange(response?.unreadChatCustomsCount));
                                dispatch(onChatCountCTChange(response?.unreadChatCTCount));
                                sendNewOrderNotification(loginUser, dispatch, userSpecificOrdersCount, response?.userSpecificOrdersCount);
                                dispatch(onUserSpecificOrdersCountChange(response?.userSpecificOrdersCount));
                                dispatch(onUnConfirmedOrdersCountChange(response?.unConfirmedOrdersCount));
                            },
                            failedCallback,
                        });
                        sendRequest(
                            `/api/order/advOrders?${addOrderFilter(loginUser, "Orders", selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, "Orders", sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}&page=${prevPage?.page == page && addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, "Orders", sortFilter, fileNumber, fileUploadStatus)?.length ? 0 : page}&size=${size}`,
                            REQUEST_ACTIONS.GET,
                            '',
                            {
                                successCallback: response => {
                                    setOrderData(dispatch, getOrders, response, loginUser, failedCallback, function (data) {
                                        setSearchSpinner(false);
                                    });
                                },
                                failedCallback,
                            },
                        );
                    });
                },
                failedCallback,
            },
        );
    }
    const getCustomsDate = (o) => {
        if (o?.astatus?.podDate) {
            if (o?.astatus?.podDate.includes(" 1970"))
                return null;
            else return o.astatus?.podDate;
        }
        if (o?.cstatus?.podDate) {
            if (o?.cstatus?.podDate.includes(" 1970"))
                return null;
            else return o.cstatus?.podDate;
        }
        if (o?.sinay?.arDate1) {
            if (o?.sinay?.arDate1.includes(" 1970"))
                return null;
            else return o.sinay?.arDate1;
        }
        if (o?.orderStage[4]?.departureStage[0]?.eta)
            return o.orderStage[4]?.departureStage[0]?.eta;
        return null;
    }
    const getDiff1 = (order, customsDate) => {
        var dt1 = order.orderStage[4]?.departureStage[0]?.eta;
        if (dt1) {
            var date1;
            if (!isNaN(dt1))
                date1 = new Date(Number(dt1));
            else
                date1 = new Date(dt1);
            date1.setHours(1);
            date1.setMinutes(0);
            date1.setSeconds(0);
            date1.setMilliseconds(0);
            var dt2 = customsDate;
            if (dt2) {
                var date2;
                if (!isNaN(dt2))
                    date2 = new Date(Number(dt2));
                else
                    date2 = new Date(dt2);
                date2.setHours(1);
                date2.setMinutes(0);
                date2.setSeconds(0);
                date2.setMilliseconds(0);
                var timeDiff = date2.getTime() - date1.getTime();
                return timeDiff;
            }
        }
        return 0;
    }
    const getGap = (order) => {
        var customsDate = getCustomsDate(order);
        if (!order.orderStage[4]?.departureStage[0]?.eta || !customsDate)
            return "";
        var delay = 0;
        var timeDiff = getDiff1(order, customsDate);
        delay = timeDiff / 86400000 | 0;
        if (delay != 0) {
            if (delay > 99)
                delay = 99;
            if (delay < -99)
                delay = -99;
            return delay;
        }
        return ""
    }
    const csvExportAdv = () => {

        setIsLoading(true);
        console.log("Start export from avd search page");

        var qp = "";
        if (loginUser.authority != "Admin" && loginUser.department != 4) {
            if (loginUser.department) {
                qp += "&userVisibility=" + loginUser.department;
            } else
                qp += "&userVisibility=1";
        }
        if (cId)
            qp += `&consigneeId=${cId}`;
        if (sId)
            qp += `&shipperId=${sId}`;
        if (bId)
            qp += `&customerId=${bId}`;
        if (ssId)
            qp += `&shippingModeId=${ssId}`;
        if (eDate) {
            var dt = new Date(eDate);
            dt.setUTCHours(23, 59, 59, 999);
            qp += `&etaDate=${dt.getTime()}`;
        }
        if (loc)
            qp += `&selectedLocation=${loc === "OTHERS" ? "ALL" : (loc === "EXP" ? "IL" : loc)}`;
        if (sortFilter1) {
            if (sortFilter1.date) {
                qp += `&sortdate=${sortFilter1.date}`;
            }
            if (sortFilter1.clientref) {
                qp += `&sortclientref=${sortFilter1.clientref}`;
            }
            if (sortFilter1.consignee) {
                qp += `&sortconsignee=${sortFilter1.consignee}`;
            }
            if (sortFilter1.shipper) {
                qp += `&sortshipper=${sortFilter1.shipper}`;
            }
            if (sortFilter1.brooker) {
                qp += `&sortbrooker=${sortFilter1.brooker}`;
            }
            if (sortFilter1.type) {
                qp += `&sorttype=${sortFilter1.type}`;
            }
            if (sortFilter1.etd) {
                qp += `&sortetd=${sortFilter1.etd}`;
            }
            if (sortFilter1.eta) {
                qp += `&sorteta=${sortFilter1.eta}`;
            }
            if (sortFilter1.orgCtr) {
                qp += `&sortorgctr=${sortFilter1.orgCtr}`;
            }
            if (sortFilter1.orgUS) {
                qp += `&sortorgus=${sortFilter1.orgUS}`;
            }
            if (sortFilter1.pol) {
                qp += `&sortpol=${sortFilter1.pol}`;
            }
            if (sortFilter1.pod) {
                qp += `&sortpod=${sortFilter1.pod}`;
            }
            if (sortFilter1.po) {
                qp += `&sortpo=${sortFilter1.po}`;
            }
            if (sortFilter1.reminder) {
                qp += `&sortreminder=${sortFilter1.reminder}`;
            }
            if (sortFilter1.location) {
                qp += `&sortlocation=${sortFilter1.location}`;
            }
        }
        if (airPolId) {
            qp += `&polId=${airPolId}`;
        } else if (seaPolId) {
            qp += `&polId=${seaPolId}`;
        }
        if (airPodId) {
            qp += `&podId=${airPodId}`;
        } else if (seaPodId) {
            qp += `&podId=${seaPodId}`;
        }
        if (etaStart) {
            qp += `&startEta=${etaStart}`;
        }
        if (etaEnd) {
            qp += `&endEta=${etaEnd}`;
        }
        if (etdStart) {
            qp += `&startEtd=${etdStart}`;
        }
        if (etdEnd) {
            qp += `&endEtd=${etdEnd}`;
        }
        if (reminderStart) {
            qp += `&startReminderDate=${reminderStart}`;
        }
        if (reminderEnd) {
            qp += `&endReminderDate=${reminderEnd}`;
        }
        sendRequest("/api/order/advOrders?showUnassignedOrders=true&page=0&size=100000&" + (loginUser.department ? "dep=" + loginUser.department : "dep=1") + (endDate ? "&endDate=" + endDate : "") + (incotermsId ? "&incotermsId=" + incotermsId : "") + (globalSearch?.trim() ? "&search=" + globalSearch?.trim() : "") + (activeSearch ? "&sort=2&showHistoryOrdersOnly=false" : "&sort=2&showHistoryOrdersOnly=true") + (userILSalesId ? ("&userLocalSalesId=" + userILSalesId) : "") + (userFU ? ("&userLocalId=" + userFU) : "") + (userFU ? ("&userILId=" + userFU) : "") + (rDate ? ("&ilReminderDate=" + rDate) : "") + qp, REQUEST_ACTIONS.GET, '', {
            successCallback: resp => {
                //console.log("data ======================");
                setOrderData(dispatch, getOrders, resp, loginUser, failedCallback, function (reap) {
                    //console.log("for ======================");
                    if (!reap)
                        return;
                    var data_main = [];
                    var header = ["File", "JOB", "PO", "Supplier Name", "Co-Loader", "QTY", "Package", "Weight", "Volume", "INCOTERMS", "Origin Country", "Load Port", "Discharge Port", "ETD", "ETA", "Vessel name", "Container", "Last Cus. Event", "Reminder", "TRANSPORT", "ARRIVAL", "TELEX MBL", "TELEX HBL", "Salesman", "Broker", "Free days"]
                    //data_main.push(header);
                    for (var i = 0; i < reap.length; i++) {
                        var query = getLocationFromId(reap[i].location?.id);
                        if (loginUser.authority != "Admin") {
                            if (loginUser.department == null && reap[i].visibilityWH)
                                query += "-H";
                            else if (loginUser.department == 1 && reap[i].visibilityWH)
                                query += "-H";
                            else if (loginUser.department == 2 && reap[i].visibilityT)
                                query += "-H";
                            else if (loginUser.department == 3 && reap[i].visibilityC)
                                query += "-H";
                        } else if (reap[i].historyFlag) {
                            query += "-H";
                        }
                        var eta = getETAE(reap[i]);
                        var etd = getETDE(reap[i]);
                        var pol = getPOL(reap[i]);
                        var pod = getPOD(reap[i]);
                        var origin = getOriginCountry(reap[i]);
                        var companyName = "";
                        if (reap[i].shippingModeId == 1)
                            companyName = (reap[i].orderStage[4].departureStage[0]?.airline ? reap[i].orderStage[4].departureStage[0]?.airline : "");
                        else
                            companyName = (reap[i].orderStage[4].departureStage[0]?.shippingLineName ? reap[i].orderStage[4].departureStage[0]?.shippingLineName : "");
                        var inco = getIncoterms(reap[i]);
                        var vol = getOrderVolume(reap[i]);
                        var wt = getOrderWeight(reap[i]);
                        var qty = getOrderQuantity(reap[i]);
                        //var broker = brokers.find(br => br.id == reap[i].customer?.id);
                        var broker = reap[i].customer;
                        var consignee = reap[i].consignee;
                        var shipper = reap[i].shipper;
                        var data = {
                            "Customer": consignee?.companyShortName ? consignee?.companyShortName : (consignee?.companyName ? consignee.companyName : "-"),
                            "File": getFileNumber(reap[i]),
                            "JOB": reap[i].jobNumber ? reap[i].jobNumber : "-",
                            "Client Ref": reap[i]?.clientRefNumber ? reap[i]?.clientRefNumber : "-",
                            "F/U": userILData.find(user => user.id == reap[i]?.userIL?.id)?.fullName,
                            "Sub Mode": getSubMode(reap[i]),
                            "Supplier Name": shipper?.companyShortName ? shipper?.companyShortName : (shipper?.companyName ? shipper.companyName : "-"),
                            "Co-Loader": getCoLoader(reap[i]),
                            "QTY": qty,
                            "Package": reap[i].shippingMode?.id == 3 ? getFCLType(reap[i]) : "-",
                            "Weight": wt,
                            "Volume": vol,
                            "INCOTERMS": inco,
                            "Origin Country": origin,
                            "Load Port": pol,
                            "Discharge Port": pod,
                            "ETD": etd,
                            "ETA": eta,
                            "Vessel name": (reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.vesselNumber) ? reap[i]?.orderStage[4]?.departureStage[0]?.vesselNumber : "-",
                            "Company Name": companyName,
                            "MAWB": reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.master ? reap[i]?.orderStage[4]?.departureStage[0]?.master : "-",
                            "HAWB": reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.house ? reap[i]?.orderStage[4]?.departureStage[0]?.house : "-",
                            "Container": (reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.containerNumber) ? reap[i]?.orderStage[4]?.departureStage[0]?.containerNumber : "-",
                            "Last Cus. Event": getLastEvent1(reap[i]),
                            "Reminder": getILReminder(reap[i]),
                            "TRANSPORT": reap[i].shippingMode?.id == 1 ? "AIR" : (reap[i].shippingMode?.id == 2 ? "LCL" : "FCL"),
                            "ARRIVAL": getGap(reap[i]),
                            "TELEX MBL": reap[i].orderStage[4]?.departureStage[0]?.telexMbl ? true : false,
                            "TELEX HBL": reap[i].orderStage[4]?.departureStage[0]?.telexHbl ? true : false,
                            "Salesman": userILNames.find(il => il.id == reap[i].userILSales?.id?.id)?.name,
                            "Broker": broker?.companyShortName ? broker?.companyShortName : (broker?.companyName ? broker?.companyName : ""),
                            "Free Days": reap[i].freeDays,
                            "WH": query
                        };
                        data_main.push(data);
                    }
                    console.log("data: " + data_main);
                    jsonToExcel(data_main, "orders", header);
                    console.log("Create xlsx")
                    setIsLoading(false);
                });
            },
            failedCallback,
        },
        );
    }

    const getTelexData = (order) => {
        var data = "";
        if (order.orderStage[4]?.departureStage[0]?.telexMbl)
            data = "MBL";
        if (order.orderStage[4]?.departureStage[0]?.telexHbl) {
            if (data === "")
                data = "MBL";
            else
                data += " + " + "HBL";
        }

    }

    const getCoLoader = (order) => {
        var col = coloaders.find(c => c.id == order.coloaderId);
        if (col?.companyShortName)
            return col.companyShortName;
        return "-";
    }

    const getILReminder = (order) => {
        if (order.ilRemindDate)
            return getDateE(order.ilRemindDate);
        return ""
    }
    const getETAE = (order) => {
        try {
            if (order?.astatus?.podDate)
                if (order?.astatus?.podDate != "null")
                    return getDateE(order?.astatus?.podDate)
            if (order?.cstatus?.podDate) {
                if (order?.cstatus?.podDate != "null")
                    return getDateE(order?.cstatus?.podDate)
            }
            if (order.orderStage[4]?.departureStage[0]?.eta)
                return new Date(order.orderStage[4]?.departureStage[0]?.eta)
            return "-";
        } catch (e) {
            return "-";
        }
    }
    const getDate = (date) => {
        if (!isNaN(date))
            date = new Date(Number(date));
        else
            date = new Date(date);
        if (date.getFullYear() < 2000)
            return "";
        var year = "" + date.getFullYear();
        return (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/" + (date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + year[2] + year[3];
    }
    const getDateE = (date) => {
        if (!isNaN(date))
            date = new Date(Number(date));
        else
            date = new Date(date);
        return date;
        var year = "" + date.getFullYear();
        return (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/" + (date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + year;
    }
    const getETDE = (order) => {
        try {
            if (order?.astatus?.polDate)
                if (order?.astatus?.polDate != "null")
                    return getDateE(order?.astatus?.polDate)
            if (order?.cstatus?.polDate)
                if (order?.cstatus?.polDate != "null")
                    return getDateE(order?.cstatus?.polDate)
            if (order.orderStage[4]?.departureStage[0]?.etd)
                return new Date(order.orderStage[4]?.departureStage[0]?.etd)
            return "-";
        } catch (e) {
            return "-";
        }
    }
    const getCreationDate = (order) => {
        try {
            return getDateE(order?.date)
        } catch (e) {
            return "";
        }
    }
    const getETA = (order) => {
        try {
            if (order?.astatus?.podDate)
                return getDate(order?.astatus?.podDate)
            if (order?.cstatus?.podDate)
                return getDate(order?.cstatus?.podDate)
            if (order.orderStage[4]?.departureStage[0]?.eta)
                return new Intl.DateTimeFormat('en-GB', {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                    /* hour: '2-digit',
                     minute: '2-digit',
                     second: '2-digit',*/
                }).format(order.orderStage[4]?.departureStage[0]?.eta)
            return "";
        } catch (e) {
            return "";
        }
    }
    const getETD = (order) => {
        try {
            if (order?.astatus?.polDate)
                return getDate(order?.astatus?.polDate)
            if (order?.cstatus?.polDate)
                return getDate(order?.cstatus?.polDate)
            if (order.orderStage[4]?.departureStage[0]?.etd)
                return new Intl.DateTimeFormat('en-GB', {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                    /* hour: '2-digit',
                     minute: '2-digit',
                     second: '2-digit',*/
                }).format(order.orderStage[4]?.departureStage[0]?.etd)
            return "";
        } catch (e) {
            return "";
        }
    }
    const getFileNumber = (order) => {
        if (order?.fileNumber)
            return order.fileNumber;
        if (order?.orderStage) {
            if (order?.orderStage[4]) {
                if (order?.orderStage[4]?.departureStage[0]?.fileNumber)
                    return order?.orderStage[4]?.departureStage[0]?.fileNumber;
            }
        }
        return "-";
    }
    const getOriginCountry = (order) => {
        var cty = countryOfOriginData?.find(country => country.id === order.countryOfOrigin?.id);
        if (cty)
            return cty.name;
        cty = USA_STATES.find(state => state.id == order.originState);
        if (cty)
            return cty.name;
        return "-";
    }
    const getPOL = (order) => {
        var obj = null;
        if (order?.shippingModeId === 1) {
            obj = airPolData?.find(pol => pol.id === order.pol?.id);
        }
        else
            obj = lclPolData?.find(pol => pol.id === order.pol?.id);
        if (obj)
            return obj.name;
        return '-';
    }
    const getPOD = (order) => {
        var obj = null;
        if (order?.shippingModeId === 1) {
            obj = airPoaData?.find(pol => pol.id === order.poa?.id);
        }
        else
            obj = lclPoaData?.find(pol => pol.id === order.poa?.id);
        if (obj)
            return obj.name;
        return '-';
    }
    const getIncoterms = (order) => {
        var inc = incotermsData.find(inco => inco.id == order?.incoterms?.id);
        if (inc)
            return inc.name;
        return "-";
    }
    const getSubMode = (order) => {
        var sub = subModeData?.find(mode => mode.id === order.subMode?.id);
        if (sub)
            return sub.name;
        return "-";
    }
    const getFCLType = (order) => {
        var res = null;
        var res1 = null;
        if (order.orderFCLDetails?.fclType20?.id) {
            res = fclType20Data.find(fcl => fcl.id == order.orderFCLDetails?.fclType20?.id);
            if (order.orderFCLDetails?.fclType40?.id) {
                res1 = fclType40Data.find(fcl => fcl.id == order.orderFCLDetails?.fclType40?.id);
            }
        }
        else if (order.orderFCLDetails?.fclType40?.id) {
            res = fclType40Data.find(fcl => fcl.id == order.orderFCLDetails?.fclType40?.id);
        }
        return res ? res.name + (res1 ? (", " + res1.name) : "") : "-"
    }
    const getLastEvent = (order) => {
        if (order.orderStatus) {
            if (order.orderStatus[8]?.status === "IN_PROGRESS" || order.orderStatus[8]?.status === "FAILED")
                return "Delivery to Consignee";
            if (order.orderStatus[7]?.status === "IN_PROGRESS" || order.orderStatus[7]?.status === "FAILED")
                return "Customs - " + getCustomStatus(order);
            if (order.orderStatus[6]?.status === "IN_PROGRESS" || order.orderStatus[6]?.status === "FAILED")
                return "ARR - " + getPodStatus(order);
            if (order.orderStatus[5]?.status === "IN_PROGRESS" || order.orderStatus[5]?.status === "FAILED")
                return "DEP - " + getPodStatus(order);
            if (order.orderStage[4]?.status === "IN_PROGRESS" || order.orderStage[4]?.status === "FAILED")
                return "Departure Waiting";
            if (order.orderStage[3]?.status === "IN_PROGRESS" || order.orderStage[3]?.status === "FAILED")
                return "In Warehouse";
            if (order.orderStage[2]?.status === "IN_PROGRESS" || order.orderStage[2]?.status === "FAILED")
                return "In Trucking";
            if (order.orderStage[1]?.status === "IN_PROGRESS" || order.orderStage[1]?.status === "FAILED")
                return "In Shipper";
            if (order.orderStage[0]?.status === "IN_PROGRESS" || order.orderStage[0]?.status === "FAILED")
                return "Need Confirmation";
        }
        return "-";
    }
    const getLastEvent1 = (order) => {
        if (order.orderStatus) {
            if (order.orderStatus[8]?.status === "IN_PROGRESS" || order.orderStatus[8]?.status === "FAILED")
                return "Delivery";
            if (order.orderStatus[7]?.status === "IN_PROGRESS" || order.orderStatus[7]?.status === "FAILED")
                return "Customs";
            if (order.orderStatus[6]?.status === "IN_PROGRESS" || order.orderStatus[6]?.status === "FAILED")
                return "ARR";
            if (order.orderStatus[5]?.status === "IN_PROGRESS" || order.orderStatus[5]?.status === "FAILED")
                return "DEP";
            if (order.orderStage[4]?.status === "IN_PROGRESS" || order.orderStage[4]?.status === "FAILED")
                return "PORT";
            if (order.orderStage[3]?.status === "IN_PROGRESS" || order.orderStage[3]?.status === "FAILED")
                return "PORT";
            if (order.orderStage[2]?.status === "IN_PROGRESS" || order.orderStage[2]?.status === "FAILED")
                return "TRUCK";
            if (order.orderStage[1]?.status === "IN_PROGRESS" || order.orderStage[1]?.status === "FAILED")
                return "SHIPPER";
            if (order.orderStage[0]?.status === "IN_PROGRESS" || order.orderStage[0]?.status === "FAILED")
                return "Confirm";
        }
        return "-";
    }
    const getPodStatus = (order) => {
        var res = 0;
        if (order.shippingModeId == 1) {
            res = order.airStatus?.lStatus ? order.airStatus?.lStatus : "";
        } else {
            res = getSinayStatus(order.sinay?.status?.val?.metadata?.shippingStatus ? order.sinay?.status?.val?.metadata?.shippingStatus : "", order.sinay?.status ? order.sinay?.status : "")
        }
        return res ? res : "";
    }
    const getCustomStatus = (order) => {
        if (order.shippingModeId == 1) {
            return order.airStatus?.lStatus ? order.airStatus?.lStatus : "";
        } else {
            return getTaskyamStatus(order.taskyam?.data?.status)
        }
    }
    const getSinayStatus = (str, status) => {
        var msg = status?.val?.message ? status?.val?.message : "";
        if (msg) {
            return msg;
        }
        return str;
    }
    const getTaskyamStatus = (id) => {
        switch (id) {
            case 0:
                return "";
            case 1:
                return "מצהר";
            case 2:
                return "זמינות";
            case 3:
                return "פקודת מסירה";
            case 4:
                return "בדיקת מכס";
            case 5:
                return "התרת מכס";
            case 6:
                return "התרת נמל";
            case 7:
                return "תעודת ליווי";
            case 8:
                return "בקשה להוצאה";
            case 9:
                return "משוב מהנמל";
            case 10:
                return "יציאת מטען";
        }
        return "-"
    }
    const formatDateTime = (date) => {
        if (!date)
            return "-";
        var dt = new Date(Number(date));
        const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
        return `${padL(dt.getDate())}/${padL(dt.getMonth() + 1)}/${dt.getFullYear().toString()}`;
    }
    const formatDateTimeE = (date) => {
        if (!date)
            return "-";
        return new Date(Number(date));
    }
    const getOrderQuantity = (order) => {
        var res = 0;
        if (order.orderDetails) {
            for (var i = 0; i < order.orderDetails.length; i++) {
                res += order.orderDetails[i].numberOfPieces;
            }
        }
        if (order.orderFCLDetails?.quantity40) {
            res += order.orderFCLDetails.quantity40
        }
        if (order.orderFCLDetails?.quantity20) {
            res += order.orderFCLDetails.quantity20
        }
        return res ? res : "";
    }
    const getOrderWeight = (order) => {
        var res = 0;
        if (order.orderDetails) {
            for (var i = 0; i < order.orderDetails.length; i++) {
                res += order.orderDetails[i].numberOfPieces * order.orderDetails[i].weightPerPiece;
            }
        }
        return res ? res : "";
    }
    const getOrderVolume = (order) => {
        var res = 0;
        if (order.orderDetails) {
            for (var i = 0; i < order.orderDetails.length; i++) {
                res += (order.orderDetails[i].numberOfPieces * order.orderDetails[i].height * order.orderDetails[i].width * order.orderDetails[i]["length"]) / 1000000;
            }
        }
        return res ? res : "";
    }
    useEffect(() => {
        sendRequest('/api/getAllData', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                console.log(response);
                dispatch(onSubModeDataChange(response.subMode));
                dispatch(onShippingModeDataChange(response.shippingMode));
                dispatch(onAirPoaDataChange(response.poaair));
                dispatch(onAirPolDataChange(response.polair));
                dispatch(onLclPoaDataChange(response.poalcl));
                dispatch(onLclPolDataChange(response.pollcl));
                dispatch(onCountryOfOriginDataChange(response.countryOfOrigin));
                dispatch(onIncotermsDataChange(response.incoterms));
                dispatch(onFileCodesChange(response.codes));
                dispatch(onFCLType20DataChange(response.fclType20));
                dispatch(onFCLType40DataChange(response.fclType40));
            },
            failedCallback,
        });
        sendRequest('/api/usersAll', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                console.log(response);
                dispatch(onUserILDataChange(response.IL));
                dispatch(onUserNLDataChange(response.NL));
                dispatch(onUserUSDataChange(response.US));
            },
            failedCallback,
        });
        sendRequest('/api/serviceProvider/lastUpdate', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                lastServiceRefresh = response;
            },
            failedCallback,
        });
        sendRequest('/api/serviceProvider/all?activeFlag=true', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                dispatch(onShippersChange(response.s1));
                dispatch(onConsigneesChange(response.s2));
                setColoaders(response.s8);
                dispatch(onCustomersChange(response.s13));
                setBrokers(response.s12);
            },
            failedCallback,
        });
    }, [dispatch, failedCallback]);

    useEffect(() => {
        const userILNameOptions = userILData?.map(user => ({
            id: user.id,
            name: user.fullName,
            department: user.department,
            active: user.active,
            roleId: user.role?.id,
        }));

        dispatch(onUserILNamesChange(userILNameOptions));
    }, [userILData, dispatch]);

    useEffect(() => {
        const userNLNameOptions = userNLData.map(user => ({
            id: user.id,
            name: user.fullName,
            department: user.department,
            active: user.active,
            roleId: user.role?.id,
        }));

        dispatch(onUserNLNamesChange(userNLNameOptions));
    }, [userNLData, dispatch]);

    useEffect(() => {
        const userUSNameOptions = userUSData.map(user => ({
            id: user.id,
            name: user.fullName,
            department: user.department,
            active: user.active,
            roleId: user.role?.id,
        }));

        dispatch(onUserUSNamesChange(userUSNameOptions));
    }, [userUSData, dispatch]);

    useEffect(() => {
        const shipperNameOptions = shippers.map(shipper => ({
            id: shipper?.id,
            name: shipper.companyName,
            serviceProviderLocationId: shipper.serviceProviderLocationId,
        }));

        dispatch(onShipperNameOptionsChange(shipperNameOptions));
    }, [shippers, dispatch]);

    useEffect(() => {
        const customerNameOptions = customers.map(customer => ({
            id: customer.id,
            name: customer.companyName,
            serviceProviderLocationId: customer.serviceProviderLocationId,
        }));

        dispatch(onCustomerNameOptionsChange(customerNameOptions));
    }, [customers, dispatch]);

    useEffect(() => {
        const consigneeNameOptions = consignees.map(consignee => ({
            id: consignee.id,
            name: consignee.companyName,
            serviceProviderLocationId: consignee.serviceProviderLocationId,
        }));

        dispatch(onConsigneeNameOptionsChange(consigneeNameOptions));
    }, [consignees, dispatch]);

    useEffect(() => {
        setIsLoaded(subModeData && shippingModeData && countryOfOriginData && userILData && userNLData && userUSData);
    }, [subModeData, shippingModeData, countryOfOriginData, userILData, userNLData, userUSData]);


    return (
        <Grid container style={{ display: `${selectedOrder ? "none" : ""}`}}>
            {!isLoaded ? (
                <Grid container item justifyContent='center' mt={8}>
                    <CircularProgress style={{ marginTop: "20px" }} />
                </Grid>
            ) : (
                <Fragment>
                    <Grid container rowSpacing={1} >
                        {!(loginUser?.authorities && loginUser?.authorities[0]?.authority === 'User' && (loginUser?.location?.code === 'NL' || loginUser?.location?.code === 'US')) ?
                            (
                                <Grid item container xs={12} alignItems="center" sx={{ padding: "0" }}>
                                    <Tabs onclick={onHideTracker} value={selectedLocationIndex} onChange={onHandleSelectedLocationIndexChange} className="locationTabsGroup" TabIndicatorProps={{ style: { display: 'none' } }} sx={{ minHeight: "30px", overflow: "hidden" }}>
                                        <StyledTab label={"NL"} className="locationTab" />
                                        <StyledTab label="US" className="locationTab" />
                                        <StyledTab label="OTHERS" className="locationTab" />
                                        <StyledTab label="EXP" className="locationTab" />
                                    </Tabs>
                                    {loginUser.fullName == "Admin" && <Tabs onChange={onHandleSelectedLocationCRM} className="locationTabsGroup" TabIndicatorProps={{ style: { display: 'none' } }} sx={{ minHeight: "30px", overflow: "hidden", marginLeft: "8px" }}>
                                        <StyledTab label="Customers" className="locationTabCust" />
                                    </Tabs>}
                                </Grid>) : null}

                        {showCRM && <Grid item container style={{}}>
                            <Grid item container style={{ marginTop: "0" }}>
                                <Customers />
                            </Grid>
                        </Grid>}
                        {!showCRM && isTrackerLoaded && <Tracker fullName={loginUser.fullName} />}
                        {!showCRM && !isTrackerLoaded && <>
                            <Grid container item xs={8} spacing={1} style={{ marginTop: '0px' }} className="subtabs">
                                {/* <Typography noWrap variant='h5'>Orders History</Typography>*/}
                                <Button variant='contained' className={selectedTabIndexName !== 'OrdersHistory' ? 'active' : ''} sx={{ fontWeight: "700", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", minWidth: "150px", fontSize: "0.75vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("Orders"));
                                    dispatch(getOrders([]));
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedOrdersCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
                                    }, 500)
                                    //agentOrders()
                                }}>
                                    &#9638;&nbsp; Orders{unConfirmedOrdersCount ? ' (' + unConfirmedOrdersCount + ')' : ''}
                                </Button>
                                <Button color='secondary' variant='contained' className={selectedTabIndexName === 'OrdersHistory' ? 'active' : ''} sx={{ fontWeight: "700", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "0px", minWidth: "150px", fontSize: "0.75vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("OrdersHistory"));
                                    dispatch(getOrders([]));
                                    // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedOrdersCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/orderHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "OrdersHistory" } })
                                    }, 500)
                                }}>
                                    &#9724;&nbsp; Order History
                                </Button>
                                {/*{selectedLocationIndex != 2 && loginUser.department != 4 && < Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("Parcels"));
                                    dispatch(getOrders([]));
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/phome", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Parcels" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Redbox
                                </Button>
                                }
                                {selectedLocationIndex != 2 && loginUser.department != 4 && <Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "17%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("ParcelsHistory"));
                                    dispatch(getOrders([]));
                                    // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/parcelHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "ParcelsHistory" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Redbox History
                                </Button>
                                }
                                {selectedLocationIndex != 2 && loginUser.department != 4 && <Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("Drops"));
                                    dispatch(getOrders([]));
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/dhome", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Drops" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Drop
                                </Button>
                                }
                                {selectedLocationIndex != 2 && loginUser.department != 4 && <Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "17%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("DropsHistory"));
                                    dispatch(getOrders([]));
                                    // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/dropHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "DropsHistory" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Drop History
                                </Button>}*/}

                            </Grid>

                            <Grid container item xs={4} justifyContent='flex-end' flexWrap="nowrap" className="orders-actions">
                                <Grid container item xs={8} justifyContent='flex-end' alignContent="flex-start" flexWrap="nowrap" className="action-buttons">
                                    <Button color='secondary' onClick={() => {
                                        onHandleOpenAdvSearchDialog();
                                    }} variant='contained' className="icon-btn" sx={{ background: "linear - gradient(#FFFFFF, #F4F7FA)", borderRadius: "12px", width: "46px", minWidth: "auto", padding: "0", height: "46px", fontSize: "20px", fontWeight: "700" }}>
                                        ☷⌕
                                    </Button>
                                    <Button color='secondary' onClick={() => {
                                        csvExport();
                                    }} variant='contained' className="icon-btn" sx={{ background: "linear - gradient(#FFFFFF, #F4F7FA)", borderRadius: "12px", width: "46px", minWidth: "auto", padding: "0", height: "46px", fontSize: "20px", fontWeight: "700" }}>
                                        ⇩
                                    </Button>
                                    {(loginUser.department == 1 || loginUser.department == 2 || loginUser.department == null) && <Button color='secondary' onClick={onHandleOpenDialog} variant='contained' className="primary-btn" sx={{ marginRight: "25px", marginLeft: "20px", padding: "0px 12px 0px 6px !important", height: "46px", gap: "8px", width: "150px" }}>
                                        <Typography noWrap component='span' sx={{ fontSize: '20px', fontWeight: 400, lineHeight: 1, margin: "0px 10px" }}>+</Typography>
                                        <Typography noWrap variant='button' style={{ textTransform: "none", fontSize: "15px", fontWeight: "700" }}>
                                            Order Info
                                        </Typography>
                                    </Button>}
                                </Grid>
                            </Grid>
                        </>}
                        {openOrderDialog &&
                            <Dialog
                                open={openOrderDialog}
                                onHandleCancel={onHandleCancelDialog}
                                title='Order information'
                                maxWidth='lg'>
                                <OrderForm loginUser={loginUser} brokers={brokers} onHandleCancel={onHandleCancelDialog} order={null} orderTableFilter={orderTableFilter} pageName='Orders' />
                            </Dialog>
                        }
                        {advSearchDialog &&
                            <Dialog
                                disableRestoreFocus
                                open={advSearchDialog}
                                onHandleCancel={onHandleCancelAdvSearchDialog}
                                title='Advanced Search'
                                //maxWidth='lg'
                                maxWidth="90vw">
                                <AdvSearchDialog
                                    selectedGeneral={selectedGeneral}
                                    setSelectedGeneral={setSelectedGeneral}
                                    onHandleChange={onHandleChange}
                                    subModeId={subModeId}
                                    subModeData={subModeData}
                                    onSubModeIdChange={onSubModeIdChange}
                                    STAGES_OPTIONS={STAGES_OPTIONS}
                                    stageSearch={stageSearch}
                                    OnStageSearchChange={OnStageSearchChange}
                                    fileNumber={fileNumber}
                                    setFileNumber={onFileNumberChange}
                                    urgentShipment={urgentShipment}
                                    onUrgentShipmentChange={onUrgentShipmentChange}
                                    advancedSearchDefaultStyle={advancedSearchDefaultStyle}
                                    resetAdvancedSearchFilter={resetAdvancedSearchFilter}
                                    globalSearch={globalSearch}
                                    setGlobalSearch={setGlobalSearch}
                                    setSearchResult={setSearchResult}
                                    isLoading={isLoading}
                                    CircularProgress={CircularProgress}
                                    globalSearchList={globalSearchList}
                                    selectedLocationIndex={selectedLocationIndex}
                                    onSelectedLocationIndexChange={onSelectedLocationIndexChange}
                                    onSearchChange={onSearchChange}
                                    setSearchSpinner={setSearchSpinner}
                                    setSearchText={setSearchText}
                                    dispatch={dispatch}
                                    sendRequest={sendRequest1}
                                    failedCallback={failedCallback}
                                    onHandleCancelAdvSearchDialog={onHandleCancelAdvSearchDialog}
                                    setOrderData={setOrderData1}
                                    loginUser={loginUser}
                                    getOrders={getOrders}
                                    csvExportAdv={csvExportAdv}
                                    resetOrderTableFilterSlice={resetOrderTableFilterSlice}
                                    origin={"O"}
                                    globalSearchList1={globalSearchList1}
                                    activeSearch={activeSearch}
                                    setActiveSearch={setActiveSearch}
                                    setEndDate={setEndDate}
                                    userILSalesId={userILSalesId}
                                    setUserILSalesId={setUserILSalesId}
                                    userILSales={userILSales}
                                    incotermsData={incotermsData}
                                    setIncotermsId={setIncotermsId}
                                    setUserFU={setUserFU}
                                    userFU={userFU}
                                    userFUData={userILImporters}
                                    rDate={rDate}
                                    setRDate={setRDate}
                                    setLoc={setLoc}
                                    cId={cId}
                                    sId={sId}
                                    ssId={ssId}
                                    setCId={setCId}
                                    setSId={setSId}
                                    setSSId={setSSId}
                                    cList={cList}
                                    sList={sList}
                                    ssList={ssList}
                                    bId={bId}
                                    setBId={setBId}
                                    bList={bList}
                                    eDate={eDate}
                                    setEDate={setEDate}
                                    usState={usState}
                                    setUsState={setUsState}
                                    ctrId={ctrId}
                                    setCtrId={setCtrId}
                                    stageId={stageId}
                                    setStageId={setStageId}
                                    ctrList={countryOfOriginData}
                                    resetSearch={resetSearch}
                                    orderCount={advOrderCount}
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    pageNum={pageNum}
                                    setPageNum={setPageNum}
                                    sortFilter={sortFilter1}
                                    onSortFilterChange={setSortFilter1}
                                    clearSort={clearSort}
                                    setAirPol={setAirPol}
                                    setAirPod={setAirPod}
                                    setSeaPol={setSeaPol}
                                    setSeaPod={setSeaPod}
                                    airPolId={airPolId}
                                    airPodId={airPodId}
                                    seaPolId={seaPolId}
                                    seaPodId={seaPodId}
                                    etaStart={etaStart}
                                    etaEnd={etaEnd}
                                    etdStart={etdStart}
                                    etdEnd={etdEnd}
                                    setEtaStart={setEtaStart}
                                    setEtaEnd={setEtaEnd}
                                    setEtdStart={setEtdStart}
                                    setEtdEnd={setEtdEnd}
                                    reminderStart={reminderStart}
                                    reminderEnd={reminderEnd}
                                    setReminderStart={setReminderStart}
                                    setReminderEnd={setReminderEnd}
                                />

                            </Dialog>
                        }
                    </Grid>
                    {(!showCRM && !isTrackerLoaded) && <><OrderTable setSelectedOrder={setSelectedOrder} filterSpinner={filterSpinner} setFilterSpinner={setFilterSpinner} loginUser={loginUser} searchSpinner={searchSpinner} pageName='Orders' searchText={searchText} setSearchText={setSearchText} />
                    </>}
                </Fragment>
            )}
        </Grid>
    );
};

export default Orders;

export const StyledTab = styled(Tab)({
    'font-size': '17px',
    'margin-right': '2px',
    'padding': '14px 16px',
    'min-height': '30px',
});
